import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import TextFieldWithButton from './ui/TextFieldWithButton';
import { getValidatedCertificateAccessToken } from '../utils/sessionStorage.js';
import { loadFromImageStore, validateAndLoadFromImageStore } from '../interact.jsx';
import { registerEvent } from '../utils/google-analytics.js';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ForgotPasswordDialog from './ui/ForgotPasswordDialog.jsx';

export default function NameValidator({
    validated,
    certificate,
    onValidated,
    onValidationFailed,
    onValidationReset,
    name,
    styleColor,
    textButtonColor,
}) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [forgotDialog, setForgotDialog] = useState(false);

    const loadingTexts = certificate.free
        ? ['loading.step1_name']
        : ['loading.step1_name', 'loading.step2', 'loading.step3'];
    const handleValidationSuccess = (imageUrl) => {
        onValidated(imageUrl, certificate);
        finishLoading();
    };

    const handleValidationFail = () => {
        onValidationFailed();
        finishLoading();
    };

    const finishLoading = () => setLoading(false);

    const handleLastName = useCallback(() => {
        setLoading(true);

        Promise.resolve(getValidatedCertificateAccessToken(certificate.id)).then((accessToken) => {
            if (accessToken) {
                loadFromImageStore(certificate.id, accessToken).then((cacheUrl) => {
                    if (cacheUrl) {
                        handleValidationSuccess(cacheUrl);
                    } else {
                        onValidationReset();
                    }
                });
            } else {
                validateAndLoadFromImageStore(certificate.id, name)
                    .then((cacheUrl) => {
                        handleValidationSuccess(cacheUrl);
                    })
                    .catch(() => {
                        handleValidationFail();
                    });
                registerEvent('validate-secret');
            }
        });
    });

    const handleNameChange = useCallback((event) => {
        onValidationReset(event.target.value);
    });
    return (
        <>
            <Stack spacing={1}>
                <TextFieldWithButton
                    text={t('certificate.enter_last_name_label')}
                    validatedText={t('certificate.encryption_key_validated')}
                    onSubmit={handleLastName}
                    key="name"
                    styleColor={styleColor}
                    textButtonColor={textButtonColor}
                    value={name}
                    status={validated}
                    errorText={t('certificate.last_name_error')}
                    loading={loading}
                    loadingTexts={loadingTexts}
                    onChange={handleNameChange}
                />
                {validated === false && !loading && (
                    <Typography
                        variant={'caption'}
                        color={'#D03232'}
                        fontWeight={700}
                        onClick={() => setForgotDialog(true)}
                        sx={{ textDecoration: 'underline', mt: 1, cursor: 'pointer' }}
                    >
                        {t('certificate.forgot_password')}
                    </Typography>
                )}
            </Stack>
            {forgotDialog && <ForgotPasswordDialog id={certificate.id} onClose={() => setForgotDialog(false)} />}
        </>
    );
}
